import React, { useEffect, useState, useRef } from 'react'
import { update_page_meta } from '../../actions/page/header'
import { connect } from 'react-redux'
import PageHeader from '../../components/page/PageHeader'
import { listTarget } from '../../actions/targets/targets'
import OrganizationScroller from '../../components/OrganizationScroller';
import { Link } from 'react-router-dom'
import { HomePageURL } from '../../assets/const'

const TargetList = ({update_page_meta, listTarget}) => {
    update_page_meta({
        title: "Target",
        description: "Targets of staffs",
      });
      const [Targets, setTargets] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(9);
    const [fetching, setFetching] = useState(false);
    const bottomElementRef = useRef();
    
    useEffect(() => {
      const fetchMore = async () => {
        if (page > totalPages || fetching) return;
        try {
          setFetching(true);
          const response = await listTarget(page, perPage);
          if (response.success) {
            setTargets((prevTargets) => {
              if (page === 1) {
                return response.targets; // Set the initial orders
              } else {
                return [...prevTargets, ...response.targets]; // Append new orders
              }
            });
            setTotalPages(response.num_pages);
            setPage(page + 1);
          }
        } catch (error) {
          console.error("Error fetching more products:", error);
        } finally {
          setFetching(false);
        }
      };
      const options = {
        root: null, // viewport
        rootMargin: "0px",
        threshold: 0.1, // When 10% of the element is visible, trigger the callback
      };
  
      const observer = new IntersectionObserver(([entry]) => {
        if (entry.isIntersecting) {
          fetchMore();
        }
      }, options);

      const bottomElement = bottomElementRef.current;
  
      if (bottomElement) {
        observer.observe(bottomElement);
      }
  
      return () => {
        if (bottomElement) {
          observer.unobserve(bottomElement);
        }
      };
    }, [bottomElementRef, page, totalPages, fetching]);
  return (
    <>
        <PageHeader title="Targets" />
        <div className="row layout-top-spacing" id="cancel-row">
                
                <div className="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                    <div className="widget-content widget-content-area br-6">
                        <OrganizationScroller />
                        <div className="table-responsive mb-4 mt-4">
                            <table id="zero-config" className="table table-hover" style={{width: "100%"}}>
                                <thead>
                                    <tr>
                                        <th className="no-content"></th>
                                        <th>User</th>
                                        <th>Target Type</th>
                                        <th>Value</th>
                                        <th>Start Date</th>
                                        <th>End Date</th>
                                        <th className="no-content"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        Targets?.map((target) => {
                                            return (
                                                <tr key={target?.id}>
                                                    <td></td>
                                                    <td>{target?.user?.full_name}</td>
                                                    <td>{target?.target_type}</td>
                                                    <td>{target?.target_value}</td>
                                                    <td>{target?.start_date}</td>
                                                    <td>{target?.end_date}</td>
                                                    <td className="cursor-pointer">
                                                        <Link to={`${HomePageURL}/targets/${target?.id}/`}>
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="feather feather-arrow-right"><line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline></svg>
                                                        </Link>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                    }
                                </tbody>
                                <tfoot ref={bottomElementRef}></tfoot>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
    </>
  )
}

export default connect(null, {update_page_meta, listTarget}) (TargetList);